const profiles = {
  header: {
    btnCreate: 'Erstellen',
  },

  toast: {
    error: {
      badResponse: '[Profil] fehlerhafte Serverantwort',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
      delete: {
        body: 'Profile wurden erfolgreich gelöscht',
      },
    },
  },
  table: {
    headers: {
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },
  forms: {
    header: {
      createProfile: {
        title: 'Erstellen',
      },

      updateProfile: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    general: {
      header: 'Allgemein',
      fields: {
        profileType: {
          label: 'Profiltyp',
          options: {
            retail: 'Einzelhandel',
            individual: 'Individuell',
            wholesale: 'Großhandel',
            corporate: 'Unternehmen',
            web: 'Web',
            hotel: 'Hotel',
            thirdParty: 'Drittanbieter',
            tourOperator: 'Fahrtbetreiber',
            receiptiveOperator: 'Empfangsoperator',
          },
        },
        rateType: {
          label: 'Tarifart',
          options: {
            connections: 'Anschlüsse',
            corporate: 'Unternehmenstarif',
            expedia: 'Expedia',
            groundTransportation: 'Bodentransport',
            holidayTaxis: 'Urlaubstaxis',
            respectiveOperator: 'Tarif des jeweiligen Betreibers',
            retail: 'Einzelhandelstraif',
            tourOperator: 'Fahrtbetreibertarif',
            viator: 'Viator',
          },
        },
        name: {
          label: 'Name',
        },
        status: {
          label: 'Status',
          options: {
            active: 'Aktiv',
            inactive: 'Inaktiv',
            onHold: 'In der Warteschleife',
          },
        },
        email: {
          label: 'E-Mail-Adresse',
        },
        startDate: {
          label: 'Startdatum',
        },
        phone: {
          label: 'Telefonnummer',
        },
        additionalPhone: {
          label: 'Zusätzliches Telefon',
        },
        fax: {
          label: 'Faxnummer',
        },
        attributes: {
          label: 'Eigenschaften',
        },
      },
    },
    billing: {
      header: 'Rechnungsdaten',
      fields: {
        name: {
          label: 'Rechnungsname',
        },
        email: {
          label: 'E-Mail-Adresse',
        },
        phone: {
          label: 'Telefonnummer',
        },
        address: {
          label: 'Adresse',
        },
        city: {
          label: 'Stadt',
        },
        state: {
          label: 'Staat',
        },
        zip: {
          label: 'PLZ',
        },
        country: {
          label: 'Land',
          options: {
            usa: 'USA',
          },
        },
      },
    },
    notes: {
      header: 'Hinweise',
      fields: {
        general: {
          label: 'Allgemein',
        },
        driver: {
          label: 'Fahrer',
        },
        dispatch: {
          label: 'Versenden',
        },
      },
    },
    complexNotes: {
      header: 'Hinweise',
      fields: {
        type: {
          label: 'Hinweistyp',
          options: {
            accident: 'Unfall',
            complaint: 'Beschwerde',
            agentIssue: '(QC) Agentenproblem',
            carIssue: '(QC) Fahrzeugproblem',
            noShow: 'Nichterscheinen',
            general: 'Allgemeiner Hinweis',
            disaptch: 'Hinweis für Disposition',
            driver: 'Hinweis für den Fahrer',
            agent: 'Agentenhinweis',
            cancel: 'Stornierungshinweis',
            booking: 'Buchungshinweis',
          },
        },
        value: {
          label: 'Hinweis Inhalt',
        },
      },
      add: 'Notiz hinzufügen',
    },
    preferences: {
      header: 'Einstellungen',
      job: {
        header: 'Reservierungspräferenzen',
        fields: {
          service: {
            label: 'Dienst',
          },
          sharedWith: {
            label: 'Geteilt mit',
          },
        },
      },
      excludedDrivers: {
        header: 'Ausgeschlossene Fahrer',
        dualList: {
          driversList: {
            header: 'Fahrerliste',
          },
          excludedList: {
            header: 'Ausgeschlossene Fahrer',
          },
        },
      },
      excludedVehicles: {
        header: 'Ausgeschlossene Fahrzeuge',
        dualList: {
          vehiclesList: {
            header: 'Fahrzeugliste',
          },
          excludedList: {
            header: 'Ausgeschlossene Fahrzeuge',
          },
        },
      },
    },
    jobHistory: {
      header: 'Reservierungsverlauf',
      lastJob: 'Letzte Reservierung: {{lastJob}}',
      firstJob: 'Erste Reservierung: {{firstJob}}',
    },
    contacts: {
      header: 'Kontakte',
      fields: {
        name: {
          label: 'Kontaktname',
        },
        type: {
          label: 'Kontakttyp',
          options: {
            sales: 'Verkäufer',
            employee: 'Mitarbeiter',
          },
        },
        email: {
          label: 'E-Mail',
        },
        phone: {
          label: 'Telefonnummer',
        },
        fax: {
          label: 'Faxnummer',
        },
        address: {
          label: 'Adresse',
        },
        city: {
          label: 'Stadt',
        },
        state: {
          label: 'Staat',
        },
        zip: {
          label: 'PLZ',
        },
        country: {
          label: 'Land',
        },
        comment: {
          label: 'Kommentar',
        },
      },
      add: 'Kontakt hinzufügen',
    },
    rules: {
      header: 'Regeln',
      fields: {
        value: 'Wert',
        discount: {
          label: 'Rabatt',
          options: {
            none: 'Niemand',
            fixed: 'Behoben',
            fixedPP: 'Festpreis pro Fahrgast',
            percent: 'Prozent',
            percentR: 'Prozent (gerundet)',
            percentRU: 'Prozent (aufgerundet)',
          },
        },
        markup: {
          label: 'Markup',
          options: {
            none: 'Niemand',
            fixed: 'Behoben',
            fixedPP: 'Festpreis pro Fahrgast',
            percent: 'Prozent',
            percentR: 'Prozent (gerundet)',
            percentRU: 'Prozent (aufgerundet)',
          },
        },
      },
    },
    passengers: {
      header: 'Fahrgäste',
      found: '{{number}} Fahrgäste gefunden',
      linkedTable: {
        title: 'Profil Fahrgastliste',
        columns: {
          passenger: 'Fahrgast',
          createdAt: 'Erstellungsdatum',
          vip: 'VIP',
          registerWith: 'Erstellt am',
          reservations: 'Reservierungen',
        },
        actions: {
          clear: 'Filter löschen',
          remove: 'Fahrgast entfernen',
        },
      },
      nonLinkedTable: {
        title: 'Liste nicht verknüpfter Fahrgäste',
        columns: {
          passenger: 'Fahrgast',
          registerDate: 'Erstellungsdatum',
          registerWith: 'Erstellen bei',
          profilesLinked: 'Profile verknüpft',
          reservations: 'Reservierungen',
        },
        actions: {
          clear: 'Filter löschen',
          add: 'Fahrgast verküpfen',
        },
      },
    },
  },
  update: {
    success: {
      content: 'Ihre Änderungen wurden erfolgreich gespeichert.',
    },
    error: {
      content: 'Änderungen konnten nicht gespeichert werden.',
    },
  },
  create: {
    success: {
      content: 'Ihr Profil wurde erstellt.',
    },
    error: {
      content: 'Profil konnte nicht erstellt werden.',
    },
  },
  delete: {
    deleteBtn: 'Löschen',
    deleteModal: {
      header: 'Profil löschen?',
      body: 'Sie sind dabei, {{number}} Profile zu löschen',
    },
  },
};

export default profiles;
